module.exports = __webpack_public_path__ + "assets/three-beeps.e5bb6ce0e67c67d64b1d663d1fd7c91e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/three-beeps.mp3
// module id = XC7J
// module chunks = 1